import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { PurchaseDocumentDetailFilters } from '../../models/PurchaseDocumentDetail';
import { ServiceEvents } from '../shared/interfaces';

const usePurchaseDocumentDetailService = () => {
    const { doGet,doDelete } = useFetch(); 
    const [fetchingGetPurchaseDocumentDetailsByPurchaseDocument, setFetchingGetPurchaseDocumentDetailsByInvoice] = useState(false);
    const [fetchingDeletePurchaseDocumentDetailsByPurchaseDocument, setFetchingDeletePurchaseDocumentDetailsByInvoice] = useState(false);


    const getPurchaseDocumentDetailsByPurchaseDocument = (filter: PurchaseDocumentDetailFilters, purchaseDocumentId: number, events: ServiceEvents = {} )=> {
        const queryString = Object.entries(filter)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.PURCHASE_DOCUMENT_DETAIL.GET_PURCHASE_DOCUMENT_DETAILS_BY_PURCHASE_DOCUMENT}?${queryString}`;
        
        doGet({
            ...events,
            url: url.replace(':id', purchaseDocumentId.toString()),
            setFetching: setFetchingGetPurchaseDocumentDetailsByInvoice
        });
    };

    const deletePurchaseDocumentDetail = (purchaseDocumentId: number, serviceManifestId: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT_DETAIL.DELETE_PURCHASE_DOCUMENT_BY_PURCHASE_DOCUMENT
                .replace(':id', purchaseDocumentId.toString())  
                .replace(':service_manifest_id', serviceManifestId.toString()),  
            setFetching: setFetchingDeletePurchaseDocumentDetailsByInvoice
        });
    };

    return {
        getPurchaseDocumentDetailsByPurchaseDocument, 
        deletePurchaseDocumentDetail,
        fetchingGetPurchaseDocumentDetailsByPurchaseDocument,
        fetchingDeletePurchaseDocumentDetailsByPurchaseDocument, 
    };
};

export default usePurchaseDocumentDetailService;

